import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { insuranceActions } from "../../../../store/insurance";
import CustomSelect from "../../../common/interactive/CustomSelect";

const InsuranceSearchDone = ({searchedData}) => {
    const dispatch = useDispatch()
    const isSearched = useSelector(state => state.insurance.searchResult)
    const [location, setLocation] = useState(null)
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [carrier, setCarrier] = useState(null)

    

    useEffect(() => {
        if (isSearched) {
            let locations = isSearched.locations.map(element => {
                let locAddress

                if (element?.contact_information?.address_1 || element?.contact_information?.city || element?.contact_information?.state || element?.contact_information?.zip) {

                    locAddress = element?.contact_information ? 
                        element.contact_information.address_1
                        + ' ' + element.contact_information.city 
                        + ' ' + element?.contact_information?.state 
                        + ' ' + element?.contact_information?.zip  
                    : 
                    ''
                } else {
                    locAddress = element?.name
                }
                return { 
                    value: element.id,
                    label: locAddress,
                    code: element.code
                }
            });

            if (searchedData && locations) {
                if (searchedData.tag == "insurance-carrier-locations") {
                    let selected = locations.find(item => item.code == searchedData.code)
                    
                    if (selected) {
                        setSelectedLocation(selected.value)
                        dispatch(insuranceActions.setFirmLocationInsuranceSelectionIndividual({
                            identifier: 'location_id',
                            data: {
                                value: selected.value
                            }
                        }))
                    } 
                    
                } else {
                    if (locations.length > 1) {

                    } else {
                        setSelectedLocation(locations[0]?.value)
                        dispatch(insuranceActions.setFirmLocationInsuranceSelectionIndividual({
                            identifier: 'location_id',
                            data: {
                                value: locations[0]?.value
                            }
                        }))
                    }
                    
                }
            }

            setLocation(locations)

            dispatch(insuranceActions.setFirmLocationInsuranceSelectionIndividual({
                identifier: 'insurance_carrier_id',
                data: {
                    value: isSearched.id
                }
            }))
            setCarrier([{value: isSearched.id, label: isSearched.name}])
        }

        
    }, [isSearched])

    const onChangeHandler = (data) => {

        dispatch(insuranceActions.setinsuranceDataID(data))
        dispatch(insuranceActions.setFirmLocationInsuranceSelectionIndividual(data))
        if (data.identifier == 'location_id') {
            setSelectedLocation(data.data.value)
        }
        // dispatch(insuranceActions.setFirmLocationInsuranceSelectionIndividual(data))
    }


    return <>
        {carrier && <div style={{width: 160}}>
            <CustomSelect label={'Carrier'} optionsData={carrier} preSelectedValue={carrier[0]?.value} action={onChangeHandler} identifier={'insurance_carrier_id'}/>
        </div>}
        {location && <div style={{width: 160}}>
            <CustomSelect label={'Location'} optionsData={location} preSelectedValue={selectedLocation} action={onChangeHandler} identifier={'location_id'}/>
        </div>}
    </>
}

export default InsuranceSearchDone